import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Seo from "@/components/Seo";
import { api } from "@/lib/api";
import { academyApi } from "@/lib/academy";

export function AcademyCertificate() {
  const { token } = useParams();
  const [cert, setCert] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    api.get(`/academy/certificates/${token}`).then((r) => setCert(r.data.certificate)).catch((e) => setError(e.response?.status === 401 ? "Sign in to view your certificates." : "Certificate not found."));
  }, [token]);

  if (error) return <section className="wrap" style={{ padding: "80px 20px" }}><p className="lead">{error}</p><Link className="btn lime" to="/academy/register">Academy sign in ↗</Link></section>;
  if (!cert) return <section className="wrap" style={{ padding: 80 }}><p>Loading…</p></section>;

  return (
    <>
      <Seo title="Your certificate | Solar Black Belt Academy" />
      <section className="wrap" style={{ padding: "60px 20px", maxWidth: 760 }} data-testid="academy-certificate">
        <div className="academy-belt-card" style={{ textAlign: "center", padding: 36 }}>
          <span className="eyebrow">INTERNAL COMPANY CREDENTIAL</span>
          <h1 style={{ margin: "18px 0 6px" }}>{cert.displayName}</h1>
          <p className="lead">{cert.scope}</p>
          <p className="micro">Issued {cert.issuedOn?.slice(0, 10)} · Renew by {cert.renewalOn?.slice(0, 10)} · Curriculum {cert.curriculumVersion}</p>
          <p className="micro">Issuer: {cert.issuer} · Signed: {cert.signatureName}</p>
          <p className="micro">Verify: /academy/verify/{cert.publicToken} — never share your private certificate URL publicly.</p>
          <a className="btn lime" data-testid="academy-certificate-pdf" href={`${process.env.REACT_APP_BACKEND_URL}/api/academy/certificates/${cert.id}/pdf`} target="_blank" rel="noopener noreferrer">Download PDF</a>
        </div>
      </section>
    </>
  );
}

export function AcademyVerifyPage() {
  const { token } = useParams();
  const [state, setState] = useState({ loading: true });
  useEffect(() => {
    academyApi.verify(token).then((d) => setState({ ...d, loading: false })).catch(() => setState({ loading: false, notFound: true }));
  }, [token]);

  return (
    <>
      <Seo title="Certificate verification | Solar Black Belt Academy" />
      <section className="wrap" style={{ padding: "70px 20px", maxWidth: 720 }} data-testid="academy-verify-result">
        {state.loading && <p>Checking…</p>}
        {state.notFound && <><h1>No active certificate found</h1><p className="lead">This verification link is invalid or the certificate was revoked. Ask the holder for the current link.</p></>}
        {state.loading === false && !state.notFound && (
          <div className="academy-belt-card">
            <span className="eyebrow">VERIFIED — ACTIVE</span>
            <h1>{state.displayName}</h1>
            <p className="lead">{state.scope}</p>
            <p className="micro">Issued {state.issuedOn} · Renew by {state.renewalOn} · Curriculum {state.curriculumVersion}</p>
            <p className="micro">Issued by {state.issuer}. Internal company credential — not a Tesla certification, not NABCEP, not a license or accredited education.</p>
          </div>
        )}
      </section>
    </>
  );
}
